// removed by extract-text-webpack-plugin
module.exports = {"flexPosition":"_3avV4wwBhd2QKK1oPhquZ_","title":"_1xEW-BElPgWKCZnaaygvNo","subTitle":"_180Cl-C4e1tpsm1SYwnEyB","searchWrapper":"_14pahjhmfGrZg86fA2YDxt","inputWrapper":"_308f1zt9YbE7LnF_bz5sU3","selectWrapper":"_22say_vI-vcxaLZvQB7j9u","customSelect":"Ff38HIG2Ena2oGZe40Pnm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/SearchEmployees/SearchEmployees.scss
// module id = 1824
// module chunks = 0